var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"-40px"}},[_c('graficobarra',{attrs:{"agrupamento":_vm.legendaspedidofil,"series":_vm.dadospedidosfil,"tipo":true}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }